import { z } from 'zod'

import Avatar from '@nxt-insurance/ui-kit/components/Avatar'
import Card from '@nxt-insurance/ui-kit/components/cards/Card'
import Spacer from '@nxt-insurance/ui-kit/components/layoutComponents/Spacer'
import { body2, caption, h4 } from '@nxt-insurance/ui-kit/core/typography'

import type { PortableTextTypeComponentProps } from '@portabletext/react'

export const REVIEW_CARD_DIMENSIONS = { width: 360, height: 220 }

const reviewCard = z.object({
  _type: z.literal('reviewCard'),
  _key: z.string(),
  initials: z.string(),
  name: z.string(),
  reviewText: z.string(),
  source: z.string(),
})

export const ReviewCard = (props: { node: PortableTextTypeComponentProps<unknown> }) => {
  const value = reviewCard.parse(props.node.value)
  return (
    <Card borderColor="uiGreyLight" className="w-reviewCard h-reviewCard gap-y-5">
      <div className="flex flex-row items-center">
        <Avatar initials={value.initials} />
        <Spacer horizontal size="small" />
        <div className="flex flex-shrink flex-grow flex-col justify-center">
          <p className={h4()}>{value.name}</p>
          <span className={caption({ emphasis: 'medium' })}>{value.source}</span>
        </div>
      </div>

      <p className={body2({ className: 'line-clamp-4' })}>{value.reviewText}</p>
    </Card>
  )
}
